import { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Card, Col, Row, Skeleton, Grid,FloatButton } from "antd";
import { MyText, MyButton } from "../../components";
import { AudioModal } from './popups/AudioPopup';
import { MaterialModal } from './popups/MaterialPopup';
import { StyledCard } from './style';
import {useTranslation} from "react-i18next";
import { fetchContentByCategoryAction } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
const isMobile = window.innerWidth < 768;

export const OurChildrens = ({ id }: { id: number }) => {
    const {t} = useTranslation("common")

    const [content, setContent] = useState<any>(null);
    const [isAudioModalVisible, setIsAudioModalVisible] = useState(false);
    const [isMaterialModalVisible, setIsMaterialModalVisible] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [loading, setLoading] = useState(true);
    const contentByCategory = useSelector((state: any) => state.materials?.contentByCategory ?? { data: null, loading: false });
    const dispatch = useDispatch();
    
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const showAudioModal = () => {
        setIsAudioModalVisible(true);
    };

    const showMaterialModal = () => {
        setIsMaterialModalVisible(true);
    };

    const handleAudioModalOk = () => {
        setIsAudioModalVisible(false);
    };

    const handleMaterialModalOk = () => {
        setIsMaterialModalVisible(false);
    };

    const handleAudioModalCancel = () => {
        setIsAudioModalVisible(false);
    };

    const handleMaterialModalCancel = () => {
        setIsMaterialModalVisible(false);
    };

    const rawContent = content?.content;

    const modifiedContent = rawContent
  ? screens.xs
      ? rawContent
          .replace(/<h1/g, '<h3')
          .replace(/<\/h1>/g, '</h3>')
          .replace(/<p(.*?)>/g, '<p$1 style="margin-bottom: 0.2em;">')
          .replace(/&nbsp;/g, ' ')
          .replace(/text-align:\s*justify;?/g, '') 
      : rawContent
          .replace(/<p(.*?)>/g, '<p$1 style="margin-bottom: 0.2em;">')
          .replace(/&nbsp;/g, ' ')
  : '';

    // useEffect(() => {
    //     const fetchContent = async () => {
    //         if (id) {
    //             try {
    //                 const fetchedContent = await fetchContentByCategory(id);
    
    //                 if (fetchedContent && fetchedContent.content) {
    //                     setContent(fetchedContent.content);
    //                 } else {
    //                     setContent(null);
    //                 }
    
    //                 setLoading(false);
    //             } catch (error) {
    //                 console.error('Error fetching content:', error);
    //                 setLoading(false);
    //             }
    //         }
    //     };
    
    //     fetchContent();
    // }, [id]);
    useEffect(() => {
        if (id) dispatch(fetchContentByCategoryAction({ categoryId: id }));
    }, [id]);

    useEffect(() => {
        if (!contentByCategory.success && !contentByCategory.failed) return;
        setContent(contentByCategory.data?.content || null);
        setLoading(false);
    }, [contentByCategory.success, contentByCategory.failed, contentByCategory.data]);
    return (
        <Row gutter={[0,24]} justify="center">
            <AudioModal
                visible={isAudioModalVisible}
                onOk={handleAudioModalOk}
                onCancel={handleAudioModalCancel}
            />

            <MaterialModal
                visible={isMaterialModalVisible}
                onOk={handleMaterialModalOk}
                onCancel={handleMaterialModalCancel}
            />
            <Col span={24}>
            <Row>
            <Col span={24}>
            <StyledCard screens={screens} style={{borderRadius: '20px'}}>
            {loading ? ( 
                <Skeleton active paragraph={false} style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
            ) : (
                <div style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '12px',
                    overflow: 'hidden'
                }}>
                    <img
                        src={content?.image}
                        alt="Article"
                        style={{
                            width: '100%',
                            height: '100%',
                            // objectFit: 'cover'
                        }}
                    />
                </div>
            )}
        </StyledCard>
            </Col>
            </Row>
            
            </Col>

            {/* <Col span={24}>
            <Row gutter={isMobile ? [8, 8] : [32, 32]}>
                <Col span={12} >
                <Link to={`/materials/detail?type=content`}
                    style={{ textDecoration: 'none' }}
                    onClick={(e) => {
                        e.preventDefault();
                        showMaterialModal();
                    }}>
                    <div style={{
                        borderRadius: '12px',
                        // width: '384px',
                        height: isMobile ? '55px' : '93px',
                        display: 'flex',
                        background: '#fff',
                        flex: '0 0 calc(50% - 12px)',
                    }}>
                        <div style={{
                            width: isMobile ? 'auto' : '83px',
                            height: isMobile ? 'auto' : '63px',
                            margin: isMobile ? '10px' : '15px',
                            overflow: 'hidden',
                            borderRadius: '5px',
                        }}>
                            <img
                                src={CardText}
                                alt="Materials"
                                style={{
                                    width: isMobile ? '53px' : '63px',
                                    height: isMobile ? '35px' : '63px',
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                        <div style={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}>
                            <MyText color='#0A033C' size={isMobile ? 12 : 20} lineHeight="24px" weight={800} style={{ fontFamily: 'Nunito' }}>
                            {`${t("materials")}`}
                            </MyText>
                        </div>
                    </div>
                </Link>
                </Col>
                <Col span={12}>

                <Link
                    to={`/materials/detail?type=content`}
                    style={{ textDecoration: 'none' }}
                    onClick={(e) => {
                        e.preventDefault();
                        showAudioModal();
                    }}
                >
                    <div style={{
                        borderRadius: '12px',
                        // width: '384px',
                        height: isMobile ? '55px' : '93px',
                        display: 'flex',
                        background: '#fff',
                        flex: '0 0 calc(50% - 12px)',
                    }}>
                        <div style={{
                            width: isMobile ? 'auto' : '83px',
                            height: isMobile ? 'auto' : '63px',
                            margin: isMobile ? '10px' : '15px',
                            overflow: 'hidden',
                            borderRadius: '5px',
                        }}>
                            <img
                                src={CardAudio}
                                alt="Audio Files"
                                style={{
                                    width: isMobile ? '53px' : '63px',
                                    height: isMobile ? '35px' : '63px',
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                        <div style={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}>
                            <MyText color='#0A033C' size={isMobile ? 12 : 20} lineHeight="24px" weight={800} style={{ fontFamily: 'Nunito' }}>
                            {`${t("audioFiles")}`}
                            </MyText>
                        </div>
                    </div>
                </Link>
                </Col>
                
            </Row>
            </Col> */}
            

        <Col span={24}>
        {/* <Card style={{borderRadius: '20px'}}> */}
            <MyText color='#0A033C' size={20} style={{ fontFamily: 'Nunito' }}>
                  <div
                    style={{ fontFamily: 'Nunito', lineHeight: '26px',fontSize: '20px' }}
                    dangerouslySetInnerHTML={{ __html: modifiedContent }}
                  />
                </MyText>
            {/* </Card> */}
        </Col>
        </Row>
    );
};
